import {
  ReadonlyBlock,
  ReadonlyField,
  ReadonlyFieldLabel,
  ReadonlyFieldRow,
  ReadonlyLabel,
} from '@/forms-legacy'

interface Props {
  label: string
  value: string
}

export function ReadonlyLoadField(props: Props) {
  const { label, value } = props

  return (
    <ReadonlyBlock>
      <ReadonlyLabel>{label}</ReadonlyLabel>

      <ReadonlyField>
        <ReadonlyFieldRow>
          <ReadonlyFieldLabel empty>{value}</ReadonlyFieldLabel>
        </ReadonlyFieldRow>
      </ReadonlyField>
    </ReadonlyBlock>
  )
}
